/*eslint-disable no-undef*/
const redirect = (path, overrideQuery, decode = true) => window.location.href = url(path, overrideQuery, decode);
/*eslint-enable no-undef*/

const url = (path, overrideQuery, decode = true) => {
    const [pathname, search] = [...path.split('?', 3)];

    const params = search ? search
        .split('&')
        .map(c => c.split('='))
        .reduce((obj, pair) => ({...obj, [pair[0]]: decode ? decodeURIComponent(pair[1]) : pair[1] }), {}) : {};

    Object.keys(overrideQuery || []).map(k => params[k] = overrideQuery[k]);

    const newQuery = Object.keys(params)
        .filter(k => params[k] !== null)
        .map(k => `${k}=${params[k]}`)
        .join('&');

    return `${pathname}${newQuery ? `?${newQuery}` : ''}`;
};

const getQueryParams = (url) => {
    if (!/\?/.test(url)) return {};

    const query = url.split('?').pop();
    const parts = query.split('&');

    return parts.reduce((p, n) => {
        let [key, value] = n.split('=');
        if (!key) return p;
        p[key] = value;
        return p;
    }, {});
};

export { redirect, url, getQueryParams };
